/**
    @description - Will let us know if we are on prod or staging
    @params - NA
    @returns - Boolean - whether we are on production
*/

export const useProduction = (): boolean => {
  // skip in server rendering
  if (typeof window === "undefined") {
    return false;
  }

  const isProductionLocation: boolean = location.origin?.includes("dataknox-erp");

  return isProductionLocation;
};
